import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography
} from "@mui/material";

import ChevronDownIcon from "assets/icons/ChevronDown";

import {directionFilesBackgroundColor} from "../constants";
import {getDirectionFileGroups} from "../helpers";
import type {MaterialFileItem as MaterialFileItemType} from "../types";
import MaterialFileItem from "./MaterialFileItem";

const DirectionFilesAccordion = ({files}: { files: MaterialFileItemType[] }) => {
  const directionFileGroups = getDirectionFileGroups(files);

  if (directionFileGroups.length === 0) {
    return null;
  }

  return (
    <Accordion
      defaultExpanded
      disableGutters
      sx={{
        p: 0,
        boxShadow: 'none',
        border: '1px solid',
        borderColor: 'grey.100',
        borderRadius: '8px !important',
        backgroundColor: directionFilesBackgroundColor,
        overflow: 'hidden',
        '&.Mui-expanded': {
          backgroundColor: directionFilesBackgroundColor,
        },
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ChevronDownIcon sx={{width: 20, height: 20}}/>}
        sx={{
          px: 2.5,
          py: 2,
          minHeight: 'auto',
          '&.Mui-expanded': {
            minHeight: 'auto',
          },
          '& .MuiAccordionSummary-content': {
            m: 0,
          },
        }}
      >
        <Typography variant="h6">
          Файлы по направлениям и проектам
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{px: 2.5, pt: 0, pb: 2.5}}>
        <Stack spacing={2}>
          {directionFileGroups.map((direction) => (
            <Box key={direction.id}>
              <Typography
                sx={{
                  mb: 1.5,
                  fontSize: 14,
                  lineHeight: '140%',
                  textTransform: 'uppercase',
                }}
              >
                {direction.name}
              </Typography>
              <Stack spacing={2}>
                {direction.files.map((file) => (
                  <MaterialFileItem key={file.id} item={file}/>
                ))}
              </Stack>
            </Box>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default DirectionFilesAccordion;
